import * as React from "react";

import "./address-book-route.scss";

import {cs, cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {csArr}              from "@Common/react/cs-arr";
import {keyed}              from "@Common/react/keyed";
import {Types}              from "@Common/types";

import {IntelligentMailBarcode} from "../../common/intelligent-mail-barcode/intelligent-mail-barcode";
import {SampleAddressSection}   from "../../common/sample-address/sample-address";
import {OfficeLayout}           from "../common/office-layout";

import {AddressListsSection}                 from "./address-lists/address-lists-section";
import {DoNotMailSection}                    from "./do-not-mail/do-not-mail-section";
import {Component as IndiciaSection}         from "./indicia/section";
import {Component as ShippingAddressSection} from "./shipping-address/section";

interface VarStack {
    isLoading : boolean,
    sections  : Types.Xpresso.Account.Office.AddressBookRoute.SectionNext[],
    session   : Types.Xpresso.Loaders.ContextNameMap['session'],
}

export const AccountAddressBookRoute = () => cst<VarStack>(
    ({}, next:any) => OfficeLayout({activeTab: "address-book", next}),
    consumeContext("session"),

    cstAssign("sections", ({session}, next) => csArr(
        [
            ShippingAddressSection,
            AddressListsSection,
            DoNotMailSection,
            IndiciaSection,
            convertAddressBookSection(IntelligentMailBarcode),
            convertAddressBookSection(({next}) => SampleAddressSection({idEntity: session.data.branch.idBranch, next})),
        ]
            .map(Component => ((next) => Component({next})))
        ,
        next,
    )),

    cstAssign("isLoading", ({sections}, next) => next(sections.some(section => section.isLoading))),

    ({isLoading, sections}) => (
        <div className="office-address-book-route-m30w">
            {isLoading ? (
                <div className="loading">Loading...</div>
            ) : (
                sections.map((section, i) => cs(
                    keyed(i),
                    () => section.render({className: "section"}),
                ))
            )}
        </div>
    ),
);

export const convertAddressBookSection = (section) => ({next}) => cs(
    ["lv1", (_, next) => section({next})],
    ({lv1}) => next(lv1 == null ? {
        isLoading: false,
        render: ({}) => null,
    } : {
        isLoading: lv1.loading,
        render: () => cs(
            ["lv2", (_, next) => lv1.render?.({next, padded: false})],
            ({lv2}) => lv2 && Section(lv2),
        )
    })
);

const Section = ({header, content}) => (
    <div className="section">
        <div className="header">
            <div className="title" xd-qa-type="label" xd-qa-name={header.title}>
                {header.title}
            </div>

            <a {...{
                className: "edit",
                onClick: () => header.action.onClick(),
                "xd-qa-type": "link",
                "xd-qa-name": header.action.xdQaName,
            }}>
                {header.action.label}
            </a>
        </div>

        {header.subtitle && (
            <div className="sub-title" xd-qa-type="label" xd-qa-name={header.subtitle}>
                {header.subtitle}
            </div>
        )}

        {content}
    </div>
);

